const setPrivacyConsentCookies = () => {
  if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
    console.warn('SEGMENT: Shopify.loadFeatures not available, skipping consent tracking setup');
    return;
  }

  window.Shopify.loadFeatures(
    [
      {
        name: 'consent-tracking-api',
        version: '0.1',
      },
    ],
    (error) => {
      if (error) {
        console.error('SEGMENT: Failed to load Shopify consent tracking API:', error);
        return;
      }
      console.info('SEGMENT: Shopify consent tracking API loaded successfully');

      if (window.Shopify.customerPrivacy) {
        setPrivacyConsent();
      }

      document.addEventListener("visitorConsentCollected", (event) => {
        console.log('visitor consent collected', event.detail);
      });
    },
  );
};

const setPrivacyConsent = () => {
  const currentConsent = window.Shopify.customerPrivacy.currentVisitorConsent();

  if (currentConsent && currentConsent.analytics !== undefined) {
    console.info('User has existing consent preferences -- analytics:', currentConsent.analytics);
  } else {
    console.info('No existing consent preferences, setting implicit consent');
    setDefaultConsent();
  }
};

const setDefaultConsent = () => {
  try {
    window.Shopify.customerPrivacy.setTrackingConsent(
      {
        analytics: true,
        preferences: true,
        marketing: true,
      },
      () => {
        console.info("Default consent set");
      }
    );
  } catch (error) {
    console.error("Failed to set default consent:", error);
  }
};

setPrivacyConsentCookies();


document.addEventListener("DOMContentLoaded", function () {
  const disclosureButton = document.querySelector(".disclosure__button");
  const disclosureList = document.querySelector(".disclosure__list-wrapper");

  if (!disclosureButton || !disclosureList) return;

  disclosureButton.addEventListener("click", function (e) {
    const expanded = disclosureButton.getAttribute("aria-expanded") === "true";
    disclosureButton.setAttribute("aria-expanded", String(!expanded));
    disclosureList.hidden = expanded; 
  });

  document.addEventListener("click", function (e) {
    if (!disclosureButton.contains(e.target) && !disclosureList.contains(e.target)) {
      disclosureButton.setAttribute("aria-expanded", "false");
      disclosureList.hidden = true;
    }
  });

  const container = document.querySelector("section.product__info-container");
  if (!container) return;

  const quantity = container.querySelector(".product-form__input.product-form__quantity");
  const buyButtons = container.querySelector(".buy-buttons-wrapper");

  if (quantity && buyButtons) {  
    const flexWrapper = document.createElement("div");
    flexWrapper.classList.add("flex");

    quantity.parentNode.insertBefore(flexWrapper, quantity);

    flexWrapper.appendChild(quantity);
    flexWrapper.appendChild(buyButtons);
  }
 
  const radios = dropdown.querySelectorAll("input[type='radio']");
  
  radios.forEach(radio => {
    radio.addEventListener("change", () => {
      toggle.textContent = radio.nextElementSibling.textContent;
      dropdown.classList.remove("open");

    
      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", radio.value);
      window.location.href = url.toString();
    });
  });
});

function initProductCards(context = document) {
  document.querySelectorAll(".product-card").forEach(card => {
    const quickAddBtn = card.querySelector(".quick-add-btn");
    const quickAddPanel = card.querySelector(".quick-add-panel");
    const addToCartBtn = card.querySelector(".add-to-cart-btn");
    const colorSwatches = card.querySelectorAll(".product-card__swatches .swatch");
    const sizeBtns = card.querySelectorAll(".quick-add-panel .size-btn");
    const productImg = card.querySelector(".product-card__img");
    const hoverImg = card.querySelector(".hover-image");
    const wishlistBtn = card.querySelector(".swym-button.swym-add-to-wishlist");
    const productUrl = card.querySelector(".product-card__url");

    const variants = JSON.parse(card.dataset.variants || "[]");
    const productTitle = card.dataset.productTitle || "";
    let selectedVariantId = null;
    let selectedColor = null;

    const updateWishlistAndUrl = (variant) => {
      if (!variant) return;

      const variantId = variant.id;
      const variantImage = variant.featured_image?.src || "";
      const variantUrl = `${window.location.origin}${variant.url || productUrl?.href || ""}`;
      const variantName = variant.name || productTitle;
      const productLink = productUrl?.href
      const baseUrl = card.dataset.shopUrl;
      const relativeUrl = productUrl.pathname + productUrl.search + productUrl.hash;
      const newProductUrl = `${baseUrl}${relativeUrl}?variant=${variantId}`;
      if (wishlistBtn) {
        wishlistBtn.dataset.variantId = variantId;
        wishlistBtn.dataset.productImage = variantImage;
        wishlistBtn.dataset.productUrl = variantUrl;
        wishlistBtn.dataset.productName = variantName;
        wishlistBtn.setAttribute("data-variant-id", variantId);
        wishlistBtn.setAttribute("data-product-image", variantImage);
        wishlistBtn.setAttribute("data-product-url", newProductUrl);
        wishlistBtn.setAttribute("data-product-name", variantName);

        console.log("Wishlist updated:", {
          variantId,
          variantImage,
          variantUrl,
          variantName
        });

        const productId = wishlistBtn.dataset.productId;
      }
    
      if (productUrl && productUrl.href) {    
        const url = new URL(productUrl.href);
        url.searchParams.delete("variant");
        url.searchParams.set("variant", variantId);
       
        productUrl.href = url.toString();
      }
    };

    quickAddBtn?.addEventListener("click", () => {
      quickAddBtn.style.display = "none";
      quickAddPanel.style.display = "block";
    });

    const images = JSON.parse(card.dataset.images || "[]");
    colorSwatches.forEach(swatch => {
      swatch.addEventListener("click", () => {
        colorSwatches.forEach(s => s.classList.remove("active"));
        swatch.classList.add("active");
        selectedColor = swatch.dataset.color?.trim();

        if (selectedColor) {
           selectedColor = selectedColor
            .toLowerCase()             
            .replace(/[^a-z0-9]/g, ""); 
        }
        
        /*const colorVariant = variants.find(v =>
          [v.option1, v.option2, v.option3]
            .filter(Boolean)
            .some(opt => opt.toLowerCase() === selectedColor.toLowerCase())
        );*/

        const normalize = str =>
          str
          ? str.toLowerCase().replace(/[^a-z0-9]/g, "")
          : "";

        const normalizedSelected = normalize(selectedColor);

        const colorVariant = variants.find(v =>
          [v.option1, v.option2, v.option3]
            .filter(Boolean)
            .some(opt => normalize(opt) === normalizedSelected)
        );

        let newImageSrc = null;

      
        const fallbackImage = images.find(imgUrl =>
          imgUrl.toLowerCase().includes(selectedColor.toLowerCase())
        );
        if (fallbackImage) {
          newImageSrc = fallbackImage;
        } 

        if (newImageSrc && productImg) {
          productImg.src = newImageSrc;

          if (productImg.srcset) productImg.srcset = "";
        }

        if(colorVariant) {
          const priceEl = card.querySelector(".product-card__price span");

          if (priceEl && colorVariant.price) {
            console.log("trying to change");
            
            const price = (colorVariant.price / 100).toFixed(2);
            priceEl.textContent = `$${price} CAD`;
          }
        }

        if (hoverImg && images.length) {
          const normalizeUrl = url => {
            if (!url) return "";

            const u = url.split("/").slice(-1)[0].toLowerCase();
            return u.split("?")[0];
          };

          const mainImageNormalized = normalizeUrl(productImg.src);

          let hoverSrc = null;
          hoverSrc = images.find(imgUrl =>
            imgUrl.toLowerCase().includes(selectedColor.toLowerCase()) &&
            normalizeUrl(imgUrl) !== mainImageNormalized
          );

          if (!hoverSrc && newImageSrc) {
            hoverSrc = images.find(imgUrl =>
              normalizeUrl(imgUrl) !== mainImageNormalized
            );
          }

          if (hoverSrc) {
            hoverImg.src = hoverSrc;

            if (hoverImg.srcset) hoverImg.srcset = "";
          }
        }
       
        sizeBtns.forEach(sizeBtn => {
          const sizeValue = sizeBtn.textContent.trim();
          const match = variants.find(v => {
            const colorMatch =
              v.option1?.toLowerCase() === selectedColor?.toLowerCase() ||
              v.option2?.toLowerCase() === selectedColor?.toLowerCase() ||
              v.option3?.toLowerCase() === selectedColor?.toLowerCase();

            const sizeMatch =
              v.option1?.toLowerCase() === sizeValue?.toLowerCase() ||
              v.option2?.toLowerCase() === sizeValue?.toLowerCase() ||
              v.option3?.toLowerCase() === sizeValue?.toLowerCase();

            return colorMatch && sizeMatch;
          });

          if (match) {
            sizeBtn.dataset.variantId = match.id;
            sizeBtn.classList.remove("disabled");
            sizeBtn.disabled = false;
          } else {
            sizeBtn.dataset.variantId = "";
            sizeBtn.classList.add("disabled");
            sizeBtn.disabled = true;
          }

          sizeBtn.classList.remove("active");
          selectedVariantId = null;
          addToCartBtn.disabled = true;
        });

        if (colorVariant) updateWishlistAndUrl(colorVariant);
      });
    });

    sizeBtns.forEach(btn => {
      btn.addEventListener("click", () => {
        if (btn.classList.contains("disabled")) return;

        sizeBtns.forEach(b => b.classList.remove("active"));
        btn.classList.add("active");

        selectedVariantId = btn.dataset.variantId;
        addToCartBtn.disabled = !selectedVariantId;

        const selectedVariant = variants.find(v => v.id == selectedVariantId);

        if (selectedVariant) updateWishlistAndUrl(selectedVariant);
      });
    });

    addToCartBtn.addEventListener("click", async () => {
      if (!selectedVariantId) return;

      try {
        const cartRes = await fetch("/cart.js");
        const cart = await cartRes.json();
        const existingItem = cart.items.find(item => item.id === selectedVariantId);

        if (existingItem) {
          await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: existingItem.key, quantity: existingItem.quantity + 1 })
          });
        } else {
          await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: selectedVariantId, quantity: 1 })
          });
        }

        addToCartBtn.textContent = "Added to Cart!";

        const scrollY = window.scrollY || window.pageYOffset;
        localStorage.setItem("cartScrollPos", scrollY);
        window.location.reload();
      } catch (err) {
        console.error("Error adding/updating cart", err);
      }
    });
  });
}


function colorSwatchesDrawer() {
  const colorSwatches = document.querySelector(".color-swatches");
  const productRecommendations = document.querySelector("tr.cart-item--related");
  const productImg = document.querySelector(".cart-drawer__recommendations img.cart-item__image");

  if (!colorSwatches || !productRecommendations || !productImg) return;

  const images = JSON.parse(productRecommendations.dataset.images || "[]");

  //console.log("Images array:", images);

  colorSwatches.addEventListener("change", (event) => {
    //console.log("Input changed");
    const input = event.target;
    if (!input.matches(".swatch-input__input")) return;

    let selectedColor = input.value.trim();

    const normalize = (str) =>
      str ? str.toLowerCase().replace(/[^a-z0-9]/g, "") : "";

    const normalizedSelected = normalize(selectedColor);

    const fallbackImage = images.find(imgUrl =>
    imgUrl.toLowerCase().includes(normalizedSelected)
    );

    //console.log("Image Found", fallbackImage);

    if (fallbackImage && productImg) {
      const finalSrc = fallbackImage.startsWith("//")
        ? `https:${fallbackImage}`
        : fallbackImage;

      productImg.src = finalSrc;

      if (productImg.srcset) productImg.srcset = "";
          
    } 
  });
}

function observeRecommendations() {
  const recommendations = document.querySelector(".cart-drawer__recommendations");
  if (!recommendations || recommendations.__observing) return;

  recommendations.__observing = true; 

  const recObserver = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList" || mutation.type === "attributes") {
        setTimeout(() => {
          colorSwatchesDrawer();
        }, 1500);
      }
    }
  });

  recObserver.observe(recommendations, {
    childList: true,
    subtree: false,
    attributes: true,
    attributeFilter: ["data-product-id"],
  });
}


function observeDrawer() {
  const drawer = document.querySelector("#CartDrawer");
  if (!drawer) return;

  const drawerObserver = new MutationObserver(() => { 
    observeRecommendations();
  });

  drawerObserver.observe(drawer, {
    childList: true,
    subtree: true,
  });
}


function cleanBundleGroupLabels() {
  document.querySelectorAll('.product-option dt').forEach((dt) => {
    if (dt.textContent.trim() === 'Part of:') {
      const dd = dt.nextElementSibling;

      if (dd) {
        dd.textContent = dd.textContent.replace(/\(group\s+[a-z0-9]+\)/gi, '').trim();
      }
    }
  });
}


function initFeelFreeLinks() {
  document.querySelectorAll('.feel-free-link').forEach(async link => {
    const generalSectionClass = 'fit-feel-general';
    if (link.getAttribute('data-popup-section') === generalSectionClass) {
      let foundSection = document.querySelector(`.${generalSectionClass} .fit-guide`);
      if (!foundSection) {
        const response = await fetch(`${window.Shopify.routes.root}pages/fit-and-feel-guide?view=fit-feel-general`);
        const text = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, "text/html");
        let fitGuides = foundSection = doc.querySelectorAll(`#MainContent .fit-guide`);
        const tempDiv = document.createElement('div');
        tempDiv.style.display = 'none';
        tempDiv.innerHTML = `<div class="${generalSectionClass}"><div class="fit-guide">
          ${Array.from(fitGuides).map(fg => `<section>${fg.innerHTML}</section>`).join('')}
        </div></div>`;
        document.body.appendChild(tempDiv);
      }
    }
    link.addEventListener('click', async function (e) {
      if (!link.hasAttribute('data-popup-section')) return;

      e.preventDefault();

      const sectionClass = this.getAttribute('data-popup-section');
      if (!sectionClass) return;

      const section = document.querySelector(`.${sectionClass} .fit-guide`);
      if (!section) {
        console.warn(`Section not found: ${sectionClass}`);
        return;
      }

      const sectionHTML = section.cloneNode(true);
      sectionHTML.style.display = 'block';
      sectionHTML.style.maxWidth = '100%';

      Swal.fire({
        html: sectionHTML.outerHTML,
        width: '90%',
        showConfirmButton: false,
        showCloseButton: true,
        customClass: {
          popup: 'fit-guide-popup'
        },
      });
    });
  });
}


function observeDiscountedPriceRemoval() {
  const cartItems = document.querySelectorAll('td.cart-item__details');
  console.log("Cart Items: ", cartItems);
  if (!cartItems.length) return;

  cartItems.forEach(cartItem => {
    const discounted = cartItem.querySelector('.cart-item__discounted-prices');
    if (!discounted) {
      const dts = cartItem.querySelectorAll('dl .product-option dt');

      dts.forEach(dt => {
        if (dt.textContent.trim() === 'Part of:') {
          console.log('Part of found');
          const optionEl = dt.closest('.product-option');
          if (optionEl) optionEl.remove();
        }
      });
    }

    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.removedNodes.length > 0) {
          mutation.removedNodes.forEach(node => {
            if (
              node.nodeType === 1 &&
                (node.matches?.('.cart-item__discounted-prices') ||
                 node.querySelector?.('.cart-item__discounted-prices'))
            ) {
              const dt = cartItem.querySelector('.product-option dl dt');

              if (dt && dt.textContent.trim() === 'Part of:') {
                const optionEl = dt.closest('.product-option');
                if (optionEl) optionEl.remove();
              }
            }
          });
        }
      }
    });

    observer.observe(cartItem, { childList: true, subtree: true });
  });
}


document.addEventListener("DOMContentLoaded", function () {
  observeDiscountedPriceRemoval();

  document.addEventListener("click", (e) => {
    const toggle = e.target.closest("#custom-dropdown__toggle-id");
    const dropdown = document.getElementById("SortByDropdown");

    if (toggle) {
      e.stopPropagation();
      dropdown.classList.toggle("open");
      return;
    }

    if (dropdown && !dropdown.contains(e.target)) {
      dropdown.classList.remove("open");
    }
  });

  const target = document.querySelector(".mobile-facets__disclosure.disclosure-has-popup");
  if (!target) return; 

  const syncClass = () => {
    if (target.hasAttribute("open")) {
      target.classList.add("menu-opening");
    } else {
      target.classList.remove("menu-opening");
    }
  };
 
  syncClass();
 
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "attributes" && mutation.attributeName === "open") {
        syncClass();
      }
    });
  });

  observer.observe(target, {
    attributes: true,
    attributeFilter: ["open"],
  });
});


subscribe(PUB_SUB_EVENTS.optionValuesUpdated, () => {
  initFeelFreeLinks();
});

document.addEventListener("DOMContentLoaded", function () {
  const swatchRadios = document.querySelectorAll(
    '.variant-color + input[type="radio"], input[type="radio"][name^="filter_"]'
  );

  swatchRadios.forEach((radio) => {
    radio.addEventListener("change", function (e) {
      
      const form = e.target.closest("form");
      if (form && typeof window.FilterForm !== "undefined") {     
        const filterFormInstance = form.closest("facet-filters-form");
        if (filterFormInstance) {
          filterFormInstance.onSubmitHandler(e);
        } else {
          form.submit();
        }
      } else if (form) {       
        form.submit();
      }
    });
  });

  let currentVariantId = new URLSearchParams(window.location.search).get("variant");

  const observer = new MutationObserver(() => {
    const newVariantId = new URLSearchParams(window.location.search).get("variant");

    if (newVariantId && newVariantId !== currentVariantId) {
      currentVariantId = newVariantId;
      initFeelFreeLinks();
      // --- 1. Update Desktop Gallery ---
      fetch(`${window.location.pathname}?variant=${currentVariantId}&section_id=product-gallery-section`)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const newGallery = doc.querySelector(".gallery-grid");
          const galleryGrid = document.querySelector(".gallery-grid");

          if (newGallery && galleryGrid) {
            galleryGrid.innerHTML = newGallery.innerHTML;
          }

          // Reinit PhotoSwipe (desktop)
          const lightboxDesktop = new PhotoSwipeLightbox({
            gallery: ".product-gallery",
            children: ".zoom-btn",
            pswpModule: PhotoSwipe
          });
      
          lightboxDesktop.init();
      });

      // --- 2. Update Mobile Gallery ---
      fetch(`${window.location.pathname}?variant=${currentVariantId}&section_id=product-gallery-section-mob`)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const newMobileGallery = doc.querySelector(".gallery-slider.product-gallery");
          const currentMobileGallery = document.querySelector(".gallery-slider.product-gallery");
          
          if (newMobileGallery && currentMobileGallery) {
            currentMobileGallery.innerHTML = newMobileGallery.innerHTML;
          }

          const swiperEl = document.querySelector(".gallery-slider.swiper");
          if (swiperEl && typeof Swiper !== "undefined") {
            new Swiper(swiperEl, {
              loop: false,
              pagination: {
                el: ".swiper-pagination",
                clickable: true,
              },
            });
          }

      
          const lightboxMobile = new PhotoSwipeLightbox({
            gallery: ".gallery-slider.product-gallery",
            children: ".zoom-btn",
            pswpModule: PhotoSwipe
          });
          
          lightboxMobile.init();
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  const productCard = document.querySelectorAll(".product-card");

  console.log("product card found: ", productCard);

  initProductCards();

  const relatedSection = document.querySelector(".related-products-section .related-products");

  if(relatedSection) {
    const observerProductCards = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
          //console.log("Related products children added, initializing product cards...");
          initProductCards();
            
          observer.disconnect();
          break;
        }
      }
    });

    observerProductCards.observe(relatedSection, { childList: true });
  }

  document.addEventListener("filter:updated", () => {
    //console.log("Filter updated!");
    setTimeout(() => {      
      initProductCards();       
    }, 1500);
  });
});


function initSwymWishlistButtons() {
  /*if (typeof _swat === "undefined") {
    setTimeout(initSwymWishlistButtons, 300);
    return;
  }

  _swat.initializeActionButtons(".product-card .swym-add-to-wishlist");*/

  document.querySelectorAll(".product-card .swym-add-to-wishlist").forEach(btn => {
    btn.addEventListener("click", function (e) {
      e.stopPropagation();
     
      btn.classList.toggle("is-active");
    });

    setTimeout(() => {    
      if (btn.classList.contains("swym-added")) {
        btn.classList.add("is-active");
      } else {
        btn.classList.remove("is-active");
      }
    }, 600);
  });
}


initSwymWishlistButtons();
initFeelFreeLinks();


document.addEventListener('DOMContentLoaded', () => {
  const customWishlistBtn = document.querySelector('#whislist-btn');
  console.log(customWishlistBtn);

  if(customWishlistBtn) {

    customWishlistBtn.addEventListener('click', (e) => {
      e.preventDefault();

      const waitForSwym = setInterval(() => {
        const swymWishlistBtn = document.querySelector('#swym-atw-pdp-button');
        if (swymWishlistBtn) {
          swymWishlistBtn.click();
          clearInterval(waitForSwym);
        }
      }, 300);
    });
  }

  const colorLabel = document.querySelector(".selected-color");
  const colorInputs = document.querySelectorAll('fieldset input[type="radio"][name*="Colour"],fieldset input[type="radio"][name*="Color"],fieldset input[type="radio"][name*="Couleur"]');

  if (!colorLabel || !colorInputs.length) return;
  
  const checked = document.querySelector('fieldset input[type="radio"][name*="Colour"]:checked,fieldset input[type="radio"][name*="Color"]:checked,fieldset input[type="radio"][name*="Couleur"]:checked');
  if (checked) colorLabel.textContent = checked.value;
 
  colorInputs.forEach(input => {
    input.addEventListener("change", e => {
      colorLabel.textContent = e.target.value;
    });
  });
});


document.addEventListener("DOMContentLoaded", async () => {
  const recentKey = "recently_viewed_products";
  const handles = JSON.parse(localStorage.getItem(recentKey)) || [];
  const container = document.getElementById("recent-finds-grid");

  // --- Attach observer first
  const observerCards = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return; 
        if (node.matches(".product-card") || node.querySelector(".product-card")) {
          console.log("Observer works! New product card added");
          initProductCards();
        }
      });
    });
  });

  observerCards.observe(container, {
    childList: true,
    subtree: true,
  });

  //console.log("Loading recent products:", handles);

  for (const handle of handles) {
    if (window.collectionsBundles && handle === "bundle-save") {
      continue;
    }

    try {
      const res = await fetch(`/products/${handle}?section_id=product-slider-item`);

      if (!res.ok) continue;
      const html = await res.text();
      container.insertAdjacentHTML("beforeend", html);
    } catch (err) {
      console.error("Error rendering product", handle, err);
    }
  }
});


document.addEventListener("DOMContentLoaded", () => {
  const textContentTest = document.querySelector('#bundle-final-price');
  console.log(textContentTest);
  
  function waitForElement(selector, callback) {
    const element = document.querySelector(selector);
    if (element) {
      callback(element);
      return;
    }

    const observer = new MutationObserver((mutations, obs) => {
      const el = document.querySelector(selector);
      if (el) {
        obs.disconnect();
        callback(el);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  waitForElement('#bundle-final-price', (target) => {
    const updateUI = () => {};

    updateUI();
    const observerUpdate = new MutationObserver(() => updateUI());
    observerUpdate.observe(target, {
      childList: true,
      characterData: true,
      subtree: true
    });
  });
});


window.addEventListener("DOMContentLoaded", () => {
  const targetDrawer = document.querySelector(".drawer");

  if (!targetDrawer) {
    console.warn("Drawer element not found.");
    return;
  }

  const loadFreeShippingBar = () => {
    //console.log("Cart drawer updated — forcing Free Shipping Bar script load...");

    const scriptId = "free-shipping-script";
    const existingScript = document.getElementById(scriptId);    
    const script = document.createElement("script");
    script.id = scriptId;
    script.src = "/cdn/shop/t/19/assets/force_free_shipping_bar_essential_apps.js";

    script.onload = () => console.log("Free Shipping Bar loaded and executed");
    document.body.appendChild(script);   
  };

  cleanBundleGroupLabels();


  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "attributes" && mutation.attributeName === "class") {
        const wasEmpty = mutation.oldValue?.includes("is-empty");
        const isNowFilled = !targetDrawer.classList.contains("is-empty");

        if (wasEmpty && isNowFilled) {
          loadFreeShippingBar();      

          //colorSwatchesDrawer();
        }
      }
    }
  });

  observer.observe(targetDrawer, {
    attributes: true,
    attributeFilter: ["class"],
    attributeOldValue: true,
  });

  const productForms = document.querySelectorAll("form[data-type='add-to-cart-form']");

  productForms.forEach((form) => {
    form.addEventListener("submit", (e) => {
        //loadFreeShippingBar();
        //document.dispatchEvent(new CustomEvent("added-cart:submit"));

        setTimeout(() => {
          fetch(script.src)
            .then((res) => res.text())
            .then((code) => {
              new Function(code)(); 
            })
            .catch((err) => console.error("Force load failed:", err));
            
        }, 1500);     
    });
  });

  let cartUpdateTimeout;

  document.addEventListener("cart-custom:updated", () => {
    clearTimeout(cartUpdateTimeout);

    cartUpdateTimeout = setTimeout(() => {
      loadFreeShippingBar();
    }, 800); 

    cartUpdateTimeout = setTimeout(() => {
      observeDiscountedPriceRemoval();
    }, 51); 
    
    cartUpdateTimeout = setTimeout(() => {
      cleanBundleGroupLabels();
    }, 50); 
    
    /*cartUpdateTimeout = setTimeout(() => {
   observeDrawer();
   }, 805); */

  });

  document.addEventListener("added-cart:form", () => {
    clearTimeout(cartUpdateTimeout);

    cartUpdateTimeout = setTimeout(() => {
      loadFreeShippingBar();
    }, 800); 

    cartUpdateTimeout = setTimeout(() => {
      observeDiscountedPriceRemoval();
    }, 51); 
    
    cartUpdateTimeout = setTimeout(() => {
      cleanBundleGroupLabels();
    }, 50); 
    
    /*cartUpdateTimeout = setTimeout(() => {
      observeDrawer();
    }, 805); */
  });


  /*document.addEventListener("added-cart:submit", () => {
    if (window.bundleProduct === "bundle-save") return;

    console.log("added to cart working");
    
    setTimeout(() => {
      loadFreeShippingBar();
    }, 800); 
    
    setTimeout(() => {
      observeDiscountedPriceRemoval();
    }, 51);
    
    setTimeout(() => {
      cleanBundleGroupLabels();
    }, 50);
  });*/

  document.addEventListener("drawer:added", () => {
    setTimeout(() => {
      cleanBundleGroupLabels();
    }, 1500); 
  });
});


// Gift card recipient form sync
document.addEventListener('DOMContentLoaded', () => {
  const recipientForm = document.querySelector('.recipient-form');
  if (!recipientForm) return;

  const sectionId = recipientForm.dataset.sectionId;
  if (!sectionId) return;

  // External form fields (the visible ones)
  const externalCheckbox = document.querySelector(`#Recipient-checkbox-${sectionId}`);
  const externalEmail = document.querySelector(`#Recipient-email-${sectionId}`);
  const externalName = document.querySelector(`#Recipient-name-${sectionId}`);
  const externalMessage = document.querySelector(`#Recipient-message-${sectionId}`);
  const externalSendOn = document.querySelector(`#Recipient-send-on-${sectionId}`);
  const externalOffset = document.querySelector(`#Recipient-timezone-offset-${sectionId}`);
  const externalControl = document.querySelector(`#Recipient-control-${sectionId}`);

  // Hidden inputs in the product form
  const formControl = document.querySelector(`#form-gift-card-control-${sectionId}`);
  const formEmail = document.querySelector(`#form-gift-card-email-${sectionId}`);
  const formName = document.querySelector(`#form-gift-card-name-${sectionId}`);
  const formMessage = document.querySelector(`#form-gift-card-message-${sectionId}`);
  const formSendOn = document.querySelector(`#form-gift-card-send-on-${sectionId}`);
  const formOffset = document.querySelector(`#form-gift-card-offset-${sectionId}`);

  if (!formControl || !formEmail || !formName || !formMessage || !formSendOn || !formOffset) return;

  // Function to sync data from external form to hidden inputs
  const syncToForm = () => {
    const isChecked = externalCheckbox && externalCheckbox.checked;

    if (isChecked) {
      // Enable and populate hidden inputs
      formControl.value = externalControl ? externalControl.value : 'if_present';
      formEmail.value = externalEmail ? externalEmail.value : '';
      formName.value = externalName ? externalName.value : '';
      formMessage.value = externalMessage ? externalMessage.value : '';
      formSendOn.value = externalSendOn ? externalSendOn.value : '';
      formOffset.value = externalOffset ? externalOffset.value : '';

      formControl.disabled = false;
      formEmail.disabled = false;
      formName.disabled = false;
      formMessage.disabled = false;
      formSendOn.disabled = false;
      formOffset.disabled = false;
    } else {
      // Disable hidden inputs when checkbox is unchecked
      formControl.disabled = true;
      formEmail.disabled = true;
      formName.disabled = true;
      formMessage.disabled = true;
      formSendOn.disabled = true;
      formOffset.disabled = true;
    }
  };

  // Listen to checkbox changes
  if (externalCheckbox) {
    externalCheckbox.addEventListener('change', syncToForm);
  }

  // Listen to field changes
  if (externalEmail) externalEmail.addEventListener('input', syncToForm);
  if (externalName) externalName.addEventListener('input', syncToForm);
  if (externalMessage) externalMessage.addEventListener('input', syncToForm);
  if (externalSendOn) externalSendOn.addEventListener('change', syncToForm);

  // Initial sync
  syncToForm();
});



// Cart Drawer Free Shipping Fix
document.addEventListener('DOMContentLoaded', () => {
  const freeShippingWrapperId = "#cmgjkxcts00eedrkqcupl6u3x"
  const drawerInnerElement = document.getElementById('drawer-inner');

  const observer = new MutationObserver(function(mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        let free_shipping = null;
        mutation.removedNodes.forEach(function(node) {
          if (node.nodeType === Node.ELEMENT_NODE && node.className === "drawer__header") {
            free_shipping_element = node.querySelector(freeShippingWrapperId);
          }
        });

        Promise.resolve().then(() => {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === Node.ELEMENT_NODE && node.className === "drawer__header") {
              const free_shipping_wrapper = node.querySelector(freeShippingWrapperId);
              free_shipping_wrapper.parentNode.removeChild(free_shipping_wrapper);
              node.appendChild(free_shipping_element);
              window.pollCartTotalEssentialApps();
            }
          });
        });
      }
    }
  });

  const config = { childList: true };

  observer.observe(drawerInnerElement, config);
});


function saveDefaultBundlePrice(bundleSelector = '.bundle-description') {
  const bundle = document.querySelector(bundleSelector);
  if (!bundle) return;

  defaultBundlePriceHTML = {
    html: bundle.innerHTML.trim(), 
    price: bundle.dataset.defaultBundlePrice,
    compare: bundle.dataset.defaultComparePrice
  };
}


function restoreDefaultBundlePrice(
  bundleSelector = '.bundle-description',
  priceContainerSelector = '.price__container'
) {
  const bundle = document.querySelector(bundleSelector);
  const priceContainer = document.querySelector(priceContainerSelector);
  if (!bundle || !defaultBundlePriceHTML) return;

  bundle.innerHTML = `
    <div>${bundle.querySelector('.on-sale-price-regular.bundle') ? 'From' : ''}</div>
    <div class="on-sale-price-regular bundle">
      ${defaultBundlePriceHTML.price}
    </div>
    <div class="price-before__bundle">
      ${defaultBundlePriceHTML.compare || ''}
    </div>
  `;

  bundle.style.display = 'block';
  if (priceContainer) priceContainer.style.opacity = 0;
}


// Bundle Price Hide
document.addEventListener('DOMContentLoaded', () => {
  const priceContainer = document.querySelector('.price__container');

  if (!priceContainer) return;
  const config = { subtree: true, characterData: true };
  let counter = 0;

  const callback = function(mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'characterData') {
        /* 
          Third time is value changed by user adding to bundle,
          first 2 is Bundle app loading and modifying price tag
        */
        if(++counter > 3) {
          //observer.disconnect();
          saveDefaultBundlePrice();

          const bundleDescription = document.querySelector('.bundle-description');
          bundleDescription.style.display = 'none';
          priceContainer.style.opacity = 1;
        }
      }
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(priceContainer, config);
});


document.addEventListener("DOMContentLoaded", () => { 
  if (window.bundleProduct !== "product.bundle") return;

  const forms = document.querySelectorAll('form[data-type="add-to-cart-form"]');

  forms.forEach((form) => {
    form.addEventListener("submit", (e) => {
      //console.log("only working on bundle pdp");

      setTimeout(() => {
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            if (cart.item_count > 0) {
              fetch('/?section_id=cart-drawer')
                .then(r => r.text())
                .then(html => {
                  const doc = new DOMParser().parseFromString(html, 'text/html');
                  const newDrawer = doc.querySelector('#CartDrawer');
                  const currentDrawer = document.querySelector('#CartDrawer');
                  if (newDrawer && currentDrawer) {
                    currentDrawer.innerHTML = newDrawer.innerHTML;
                    document.dispatchEvent(new CustomEvent("cart-custom:updated"));
                    const drawerEl = document.querySelector(".drawer");
                    if (drawerEl) drawerEl.classList.add('active');   

                    restoreDefaultBundlePrice();
                  }
              });
          }
        });
      }, 800);
    });
  });
});


document.querySelectorAll('a.header__menu-item').forEach(item => {
  item.addEventListener('mouseenter', () => {
    const menu = document.querySelector('.custom-categories-menu');
    if (menu && menu.hasAttribute('open')) {
      menu.removeAttribute('open');
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const relatedProducts = document.querySelector(".related-products");
  if (!relatedProducts) return;
  
  const checkAndRemoveMinHeight = () => {
    if (relatedProducts.children.length > 0) {
      relatedProducts.removeAttribute("style");
      observer.disconnect();
    }
  };

  const observer = new MutationObserver(() => {
    checkAndRemoveMinHeight();
  });

  observer.observe(relatedProducts, { childList: true, subtree: false });

  checkAndRemoveMinHeight();
});


document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('#ContactForm');
  const reasonInput = document.querySelector('#ContactForm-reason'); 
  const reasonButton = document.querySelector('#ContactForm-reason-button');

  if (!form || !reasonInput || !reasonButton) return;

  form.addEventListener('submit', function (event) {
    const value = reasonInput.value.trim();
    if (!value) {      
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      //console.log("Propagation stopped");

      const errorHTML = `
        <small class="contact__field-error" id="ContactForm-reason-error">
          <span class="visually-hidden">This field is required</span>
          <span class="form__message">
            This field is required
          </span>
        </small>
      `;

      reasonButton.insertAdjacentHTML('afterend', errorHTML);

      return false;
    }  
  });
});


// FORCE PRESELECT ALL COOKIE BANNER OPTIONS ON OPEN(BAD IDEA)
document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver(mutationsList => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE && node.id === 'shopify-pc__prefs') {
            const checkboxes = node.querySelectorAll('input[type="checkbox"]');
            for (let i = 0; i < checkboxes.length; i++) {
              checkboxes[i].click();
            }
          }
        }
      }
    }
  });

  observer.observe(document.querySelector('body'), { childList: true }); 
});


document.addEventListener("DOMContentLoaded", () => {
  observeDrawer();
});